import {Uppercase} from "styles/components";
import {Container, View} from "../../../../styles/business-components";
import {Button, Variant} from "../../../Button";
import * as S from './styles'

import Image from '../../../../assets/images/business/b_m_cnt15_img1.png'
import Image2 from '../../../../assets/images/business/b_m_cnt15_img2.png'

export const Content15 = () => {
    return (
        <Container>
            <View>
                <S.Content>
                    <S.Stories>
                        <S.Story>
                            <S.StoryImage src={Image}/>
                            <S.StoryGlider/>
                            <S.StoryTextBlock>
                                <S.StoryTitle>Edelcoin</S.StoryTitle>
                                <S.StoryText>
                                    Защита данных для некоторых компаний или провайдеров является навязанным злом,
                                    поскольку потенциально ставит под угрозу их экономическую...
                                </S.StoryText>
                            </S.StoryTextBlock>
                            <S.StoryButton variant={Variant.Business}>Читать историю целиком</S.StoryButton>
                        </S.Story>
                        <S.Story>
                            <S.StoryImage src={Image2}/>
                            <S.StoryGlider/>
                            <S.StoryTextBlock>
                                <S.StoryTitle>Hulbee</S.StoryTitle>
                                <S.StoryText>
                                    TeleGuard бесплатен, но мы благодарны за любую поддержку.
                                    Ваш вклад будет направлен на улучшение продукта или угощение нашей команды чашкой...
                                </S.StoryText>
                            </S.StoryTextBlock>
                            <S.StoryButton variant={Variant.Business}>Читать историю целиком</S.StoryButton>
                        </S.Story>
                        <S.Story>
                            <S.StoryImage src={Image}/>
                            <S.StoryGlider/>
                            <S.StoryTextBlock>
                                <S.StoryTitle>Edelcoin</S.StoryTitle>
                                <S.StoryText>
                                    TeleGuard бесплатен, но мы благодарны за любую поддержку.
                                    Ваш вклад будет направлен на улучшение продукта или угощение нашей команды чашкой...
                                </S.StoryText>
                            </S.StoryTextBlock>
                            <S.StoryButton variant={Variant.Business}>Читать историю целиком</S.StoryButton>
                        </S.Story>
                    </S.Stories>
                    <S.TextBlock>
                        <div>
                            <S.Title>
                                Вдохновитесь реальными историями людей, которые{'\n'}
                                ведут свой бизнес{'\n'}
                                в Teleguard
                            </S.Title>
                        </div>
                        <Button variant={Variant.Business}><Uppercase>Читать все истории</Uppercase></Button>
                    </S.TextBlock>
                </S.Content>
            </View>
        </Container>
    )
}